import { listUserGroupsToPreloadAPI } from '@/service';
import { useQuery } from '@tanstack/react-query';
import { HcLinearAuth } from '@hclinear/hc-linear-react';

const listUserGroupsToPreloadBaseQueryKey = 'listUserGroupsToPreload';
const listUserGroupsToPreloadQueryKey = [listUserGroupsToPreloadBaseQueryKey];

const listUserGroupsToPreloadFetchFunction = listUserGroupsToPreloadAPI;

export const useListUserGroupsToPreloadQuery = () => {
  return useQuery({
    queryKey: listUserGroupsToPreloadQueryKey,
    queryFn: listUserGroupsToPreloadFetchFunction,
    enabled: HcLinearAuth.isAuthenticated(),
  });
};

export const useGroupPreload = (savedGroupIds: number[]): number[] => {
  const { data: preloadGroups } = useListUserGroupsToPreloadQuery();

  if (savedGroupIds) {
    return savedGroupIds;
  }

  return preloadGroups?.map((group) => group.id);
};
